import { TabsContent } from '@/components/ui/tabs';
import { GeneralLedgerView } from '@/components/general-ledger/GeneralLedgerView';
import type { Fund } from '@/types';

interface GeneralLedgerTabProps {
  fund: Fund;
}

export function FundGeneralLedgerTab({ fund }: GeneralLedgerTabProps) {
  return (
    <TabsContent value="general-ledger" className="flex-1 flex flex-col">
      <GeneralLedgerView fundId={fund.id} fund={fund} className="flex-1" />
    </TabsContent>
  );
}
